import React from "react"

const DownloadButtons = ({
  appleLink,
  playStoreLink,
  appleIcon,
  playstoreIcon,
}) => (
  <ul className="list-inline my-5">
    <li className="list-inline-item">
      <a href={appleLink}>
        {" "}
        <img
          src={appleIcon}
          className="img-fluid"
          alt="Download on apple store"
          title="Download on apple store"
          width="150"
        />
      </a>
    </li>

    <li className="list-inline-item">
      <a href={playStoreLink}>
        <img
          src={playstoreIcon}
          className="img-fluid"
          alt="Download on google play store"
          title="Download on google play store"
          width="150"
        />
      </a>
    </li>
  </ul>
)
export default DownloadButtons
